import { createContext, useState } from "react";

const Context = createContext();

const ContextProvider = ({ children }) => {
  const [role, setRole] = useState("admin");
  const [sidebar, setSidebar] = useState(true);
  const [userData, setUserData] = useState({});
  const [accessToken, setAccessToken] = useState("");

  return (
    <Context.Provider
      value={{
        role,
        setRole,
        accessToken,
        setAccessToken,
        sidebar,
        setSidebar,
        userData,
        setUserData,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export { Context, ContextProvider };
